export type EnvVars = {
  RUNTIME_ENV: string | undefined
  RUNTIME_URL: string | undefined
  RUNTIME_API_URL: string | undefined
  RUNTIME_TRY_ON_URL: string | undefined
  NEXT_PUBLIC_AUTH_URL: string | undefined
}

export type Env = {
  env: string
  development: boolean
  staging: boolean
  production: boolean
  frontendUrl: string
  frontend: string
  domain: Domain
  auth_url: string
  RUNTIME_API_URL: string
  RUNTIME_TRY_ON_URL: string
}

const vars: EnvVars = typeof window === 'undefined' ? process.env : (window as any).__ENV__

type Domain = 'atelier' | 'dresscode' | 'showoff'

function getDomain(frontendUrl: string): Domain {
  frontendUrl = frontendUrl.replaceAll('/', '')
  const atelier = frontendUrl.endsWith('.atelierdigital.ai') || frontendUrl.endsWith('.apiresq.com')
  const dresscode = frontendUrl.endsWith('.dresscode.ai')
  return atelier ? 'atelier' : dresscode ? 'dresscode' : 'showoff'
}

export function getAtelierHost(frontendUrl: string): string {
  return frontendUrl.replaceAll('/', '').endsWith('.apiresq.com') ? 'apiresq.com' : 'atelierdigital.ai'
}

function buildEnvironment(): Env {
  const { RUNTIME_ENV, RUNTIME_URL, RUNTIME_API_URL, NEXT_PUBLIC_AUTH_URL, RUNTIME_TRY_ON_URL } = vars
  const env = RUNTIME_ENV ?? 'production'
  const development = env === 'development'
  const staging = env === 'staging'
  const production = !staging && !development
  const frontendUrl = RUNTIME_URL ?? ''
  const frontend = 'showoff_catalog'
  const domain = getDomain(frontendUrl)
  const atelier = domain === 'atelier'
  const auth_url = atelier ? `https://auth2.${getAtelierHost(frontendUrl)}` : (NEXT_PUBLIC_AUTH_URL || '')

  return {
    env,
    development,
    staging,
    production,
    frontendUrl,
    frontend,
    domain,
    auth_url,
    RUNTIME_API_URL: RUNTIME_API_URL || '',
    RUNTIME_TRY_ON_URL: RUNTIME_TRY_ON_URL || '',
  }
}

export const server = typeof window === 'undefined'
export const client = !server
export const env = buildEnvironment()

export const app_version = process.env.NEXT_PUBLIC_VERSION

export const getTryonUrl = () => {
  return env.RUNTIME_TRY_ON_URL
}

export function getShareHost() {
  const stage = !env.production
  if (stage) return 'https://share-stage.showoff.app'
  const atelier = env.domain === 'atelier'
  if (atelier) return `https://share.${getAtelierHost(env.frontendUrl)}`
  const dresscode = env.domain === 'dresscode'
  return dresscode ? 'https://share.dresscode.ai' : 'https://share.showoff.app'
}

export function getSupportLink() {
  const stage = !env.production
  if (stage) return 'https://www.showoff.app/support'
  const atelier = env.domain === 'atelier'
  if (atelier) return 'https://atelierdigitalai.com/support'
  const dresscode = env.domain === 'dresscode'
  return dresscode ? 'https://dresscode.ai/support' : 'https://www.showoff.app/support'
}
